export default {
	trackEvent(event) {
		window.dataLayer = window.dataLayer || [];
		console.log('Track event', event);
		dataLayer.push(event);
	}
};
